import {makeAutoObservable} from "mobx";
import {
    ScanDocumentArchiveBatchItemDto,
    ScanDocumentArchivedSocketEventDto,
    ScanDocumentListItemDto
} from "../../api/sea";
import {api, catchApi} from "../../api";
import {growlStore} from "../GrowlStore";

interface StatusItem {
    status: 'PROGRESS' | 'SUCCESS' | 'FAILURE'
}


class SeaDocumentArchiveStore {
    get requests(): Map<string, Map<string, StatusItem>> {
        return this._requests;
    }

    set requests(value: Map<string, Map<string, StatusItem>>) {
        this._requests = value;
    }
    get executing(): boolean {
        return this._executing;
    }

    private set executing(value: boolean) {
        this._executing = value;
    }

    private get items(): Map<string, ScanDocumentArchiveBatchItemDto> {
        return this._items;
    }

    private set items(value: Map<string, ScanDocumentArchiveBatchItemDto>) {
        this._items = value;
    }

    get isEmpty(): boolean {
        return this.items.size === 0
    }

    get count(): number {
        return this.items.size
    }

    private _items: Map<string, ScanDocumentArchiveBatchItemDto> = new Map<string, ScanDocumentArchiveBatchItemDto>()
    private _requests: Map<string, Map<string, StatusItem>> = new Map<string, Map<string, StatusItem>>()
    private _executing: boolean = false

    constructor() {
        makeAutoObservable(this)
    }

    selected(item: ScanDocumentListItemDto): boolean {
        return this.items.has(item.id)
    }

    toggle(item: ScanDocumentListItemDto, checked: boolean) {
        if (checked) {
            this.items.set(item.id, {
                scanDocumentId: item.id,
                version: item.version
            })
        } else {
            this.items.delete(item.id)
        }
    }

    async archive() {
        const items = Array.from(this.items.values())
        const requestId = crypto.randomUUID()

        const requestStatusItems = items.reduce((b, c) => {
            b.set(c.scanDocumentId, {status: 'PROGRESS'})
            return b
        }, new Map<string, StatusItem>())
        this.requests.set(requestId, requestStatusItems)

        this.executing = true
        await catchApi(async () => await api.sea.api.archiveScanDocuments({
            requestId,
            items
        }))
        this.items.clear()
        this.executing = false
    }

    processSocketEvent(event: ScanDocumentArchivedSocketEventDto) {
        const requestBuffer = this.requests.get(event.requestId)
        if (!requestBuffer) {
            return
        }
        requestBuffer.set(event.scanDocumentId, {
            status: event.successful ? 'SUCCESS' : 'FAILURE'
        })
        this.requests.set(event.requestId, requestBuffer)
        if (!event.successful) {
            growlStore.add({
                cls: 'is-danger',
                closable: true,
                autoclose: true,
                message: `Archivierung von Dokument ${event.scanDocumentId} fehlgeschlagen`
            })
        }
    }
}

const seaDocumentArchiveStore = new SeaDocumentArchiveStore()

export {
    seaDocumentArchiveStore
}
